import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { formatError } from "@/lib/format-error";

/**
 * Magic-link landing route. Supabase JS exchanges the code automatically when
 * detectSessionInUrl=true (set in supabase.ts). We just wait for the session
 * to settle, then redirect home.
 */
export function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data, error } = await supabase.auth.getSession();
      if (cancelled) return;
      if (error) {
        setError(formatError(error));
        return;
      }
      if (data.session) {
        navigate("/", { replace: true });
      } else {
        // No session yet; subscription below will fire when it lands.
      }
    })();

    const { data: sub } = supabase.auth.onAuthStateChange((_event, s) => {
      if (s) navigate("/", { replace: true });
    });
    return () => {
      cancelled = true;
      sub.subscription.unsubscribe();
    };
  }, [navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "var(--fg-2)",
        fontSize: "var(--type-body)",
      }}
    >
      {error ? `Sign-in failed: ${error}` : "Signing you in…"}
    </div>
  );
}
